import { render, staticRenderFns } from "./messageBoard.vue?vue&type=template&id=2c09084a&"
import script from "./messageBoard.vue?vue&type=script&lang=js&"
export * from "./messageBoard.vue?vue&type=script&lang=js&"
import style0 from "./messageBoard.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports